import React, { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import "../styles/Hero.css";
import AnimatedTitle from "../components/AnimatedTitle";
import call from "../assets/call1.png";

const words = [
  "FAMILY TRIPS",
  "CORPORATE TRAVEL",
  "WEDDINGS",
  "TOUR PACKAGES",
  "AIRPORT TRANSFER",
];

const Hero = () => {
  const [currentWordIndex, setCurrentWordIndex] = useState(0);

  useEffect(() => {
    const wordInterval = setInterval(() => {
      setCurrentWordIndex((prev) => (prev + 1) % words.length);
    }, 2000);

    return () => clearInterval(wordInterval);
  }, []);

  const handleMove = (e) => {
    const btn = e.currentTarget;
    const circle = btn.querySelector(".hover-circle");

    const rect = btn.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;

    circle.style.left = x + "px";
    circle.style.top = y + "px";
  };

  const letterVariants = {
    initial: { opacity: 0, y: 20 },
    animate: (i) => ({
      opacity: 1,
      y: 0,
      transition: {
        delay: i * 0.05,
        duration: 0.4,
      },
    }),
    exit: { opacity: 0, y: -20, transition: { duration: 0.3 } },
  };

  const fadeUp = {
    hidden: { opacity: 0, y: 40 },
    visible: {
      opacity: 1,
      y: 0,
      transition: { duration: 0.8, ease: "easeOut" },
    },
  };

  const currentWord = words[currentWordIndex];

  return (
    <section
      className="hero"
      id="home"
      aria-labelledby="hero-main-title"
      itemScope
      itemType="https://schema.org/Service"
    >
     
      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "Service",
          "name": "Tempo Traveller Rental Service",
          "provider": {
            "@type": "Organization",
            "name": "Maha Cabs",
            "url": "https://mahacabs.co"
          },
          "serviceType": "Tempo Traveller Rental",
          "areaServed": "India",
          "description":
            "Premium Tempo Traveller rental service for family trips, corporate travel, weddings, tours, and airport transfers across India."
        })}
      </script>


      <script type="application/ld+json">
        {JSON.stringify({
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Maha Cabs - Tempo Traveller Rental",
          "url": "https://mahacabs.co",
          "telephone": "+919486589488",
          "image": "https://mahacabs.co/logo.png",
          "priceRange": "₹₹",
          "address": {
            "@type": "PostalAddress",
            "addressCountry": "IN"
          },
          "areaServed": {
            "@type": "Country",
            "name": "India"
          },
          "sameAs": [
            "https://mahacabs.co"
          ],
          "description":
            "Maha Cabs provides Tempo Traveller rental services for family trips, corporate travel, weddings, tours, and airport transfers across India."
        })}
      </script>

      <motion.div
        className="hero-left"
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.2 }}
        variants={fadeUp}
      >
        <motion.p variants={fadeUp}>
          <AnimatedTitle
            text="Tempo Traveller Rental Service Across India"
            className="hero-tag"
          />
        </motion.p>

        <motion.h1 variants={fadeUp} id="hero-main-title" itemProp="name">
          TRAVEL COMFORTABLY WITH <br />
          <span>TEMPO TRAVELLER</span>
        </motion.h1>

        <h2 style={{ position: "absolute", left: "-9999px" }}>
          Best Tempo Traveller Rental Service in India
        </h2>

        <motion.div className="booking-line" variants={fadeUp}>
          <span className="static-booking">BOOKING FOR</span>

          <AnimatePresence mode="wait">
            <motion.div
              key={currentWordIndex}
              className="dynamic-text"
              initial="initial"
              animate="animate"
              exit="exit"
              style={{ display: "flex", flexWrap: "wrap" }}
              aria-live="polite"
            >
              {currentWord.split("").map((letter, i) => (
                <motion.span
                  key={`${letter}-${i}`}
                  variants={letterVariants}
                  custom={i}
                  style={{ display: "inline-block", marginRight: "3px" }}
                >
                  {letter === " " ? "\u00A0" : letter}
                </motion.span>
              ))}
            </motion.div>
          </AnimatePresence>
        </motion.div>

        <motion.p className="hero-desc" variants={fadeUp} itemProp="description">
          Experience safe, comfortable, and hassle-free group travel with our
          premium Tempo Traveller rental services. We provide well-maintained
          vehicles with experienced drivers for family trips, corporate travel,
          tours, weddings, and long-distance journeys across India. Book your
          ride today and enjoy a smooth and memorable travel experience.
        </motion.p>

        <motion.div className="cta-row" variants={fadeUp}>
          <a
            href="tel:+919486589488"
            className="call-btn1 btn-6"
            onMouseEnter={handleMove}
            onMouseLeave={handleMove}
            aria-label="Call for Tempo Traveller booking"
            itemProp="telephone"
          >
            <span className="hover-circle"></span>

            <img
              src={call}
              alt="Call button for Tempo Traveller booking"
              className="call-icon1"
            />
            Call Now
          </a>
        </motion.div>

        <motion.div className="whatsapp-row" variants={fadeUp}>
          <a
            href="https://wa.me/9486589488"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="WhatsApp for Tempo Traveller booking"
          ></a>
        </motion.div>
      </motion.div>
    </section>
  );
};

export default Hero;
